define('app/sdc/transclude/target/sdc-transclude-target',[],function () {
	return {
		restrict: "A",
		controller: {
			bind: {
				"_transcludes": "=sdcTranscludeTarget"
			},
			properties: {
				transcludes: function transcludes_get() {
					if (!angular.isObject(this._transcludes)) {
						return [this._transcludes];
					}
					else {
						return this._transcludes;
					}
				}
			},
			constructor: ["$self", "$watch", function (vm, $watch) {
				var previousTransclude;
				$watch.collection("vm.transcludes", updateTranscludes);
				function updateTranscludes(current, previous) {

				}
			}]
		}
	};
});
